module.exports = __webpack_public_path__ + "media/images/team/petr-005b708616179ab3e5946b661774295d.jpg";